//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import draggable from "vuedraggable";

export default {
  components: {
    draggable
  },
  data() {
    return {
      loadComplete: false,
      selected: [],
      warehouses: [],
      suppliers: []
    };
  },
  async mounted() {
    await this.loadWarehouses();
    this.suppliers = await this.getSuppliers();
  },

  computed: {
    warehousesToBeWatched() {
      return this.warehouses.map(warehouse => ({ ...warehouse }));
    }
  },

  watch: {
    warehousesToBeWatched: {
      async handler(newValue, oldValue) {
        if (oldValue === undefined) {
          return;
        }

        if (newValue.length !== oldValue.length) {
          return;
        }

        for (var i = 0; i < newValue.length; i++) {
          var newWarehouse = newValue[i];
          var oldWarehouse = oldValue[i];

          newWarehouse.priority = i + 1;

          if (
            newWarehouse.generateOrder != oldWarehouse.generateOrder &&
            !newWarehouse.generateOrder
          ) {
            if (newWarehouse.sendOrder) {
              newWarehouse.sendOrder = false;
              this.warehouses = [
                ...this.warehouses.slice(0, i),
                newWarehouse,
                ...this.warehouses.slice(i + 1, this.warehouses.length)
              ];

            }
            await this.putWarehouse(newWarehouse);
            continue;
          }

          if (
            newWarehouse.sendOrder != oldWarehouse.sendOrder &&
            newWarehouse.sendOrder
          ) {
            if (!newWarehouse.generateOrder) {
              newWarehouse.generateOrder = true;
              this.warehouses = [
                ...this.warehouses.slice(0, i),
                newWarehouse,
                ...this.warehouses.slice(i + 1, this.warehouses.length)
              ];
            }
            await this.putWarehouse(newWarehouse);
            continue;
          }

          if (JSON.stringify(newWarehouse) !== JSON.stringify(oldWarehouse)) {
            await this.putWarehouse(newWarehouse);
          }
        }
      },
      immediate: false,
      deep: true
    }
  },

  methods: {
    ...mapActions("main", ["getWarehouse", "getSuppliers", "putWarehouse"]),

    async loadWarehouses() {
      this.warehouses = [];
      this.selected = [];
      this.loadComplete = false;

      var result = await this.getWarehouse();
      this.warehouses = result.sort((a, b) => a.priority - b.priority);
      this.loadComplete = true;
      window.dispatchEvent(new Event("resize"));
    }
  }
};
